module.exports = __webpack_public_path__ + "static/media/WorkOfficeBuilding.42dbbb7f.svg";